import { Link } from "react-router-dom";
import "./SidebarItem.css";
import { useEffect, useState } from "react";

export default function SidebarItem(props) {
  const [refrenceInUrl, setRefrenceInUrl] = useState(true);

  setInterval(() => {
    setRefrenceInUrl(window.location.href);
  }, 100);

  let subList;
  if (props.subList !== undefined) {
    subList = (
      <div
        className={
          props.refrence === "/Report" ? "sublist report-sublist" : "sublist"
        }
      >
        <ul>
          {props.subList.map((item) => {
            if (props.title === "گزارش") {
              return (
                <li key={item.id}>
                  <Link to={`${props.refrence}/${item.id}`}>
                    {item.caption}
                  </Link>
                </li>
              );
            } else {
              return (
                <li className="sub-item">
                  {item.name}
                  <div className="submenu">
                    <ul>
                      {item.value.map((x) => (
                        <li key={x.id}>
                          <Link to={`${props.refrence}/${x.id}`}>
                            {x.caption}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
              );
            }
          })}
        </ul>
      </div>
    );

    return (
      <li className="side-item">
        <div className="side-item-main">
          <div className={"position-relative"}>
            <span
              className={
                props.refrence === undefined
                  ? ""
                  : refrenceInUrl.toString().includes(props.refrence)
                  ? "setBg"
                  : ""
              }
            >
              {props.icon && <props.icon />}
            </span>
          </div>

          <span className={"mt-3"}>{props.title}</span>
        </div>
        {subList}
      </li>
    );
  } else {
    return (
      <li className="side-item">
        <Link className="side-item-main" to={props.refrence}>
          {console.log(props.title)}
          <div className={"position-relative"}>
            <span
              className={
                props.refrence === undefined
                  ? ""
                  : refrenceInUrl.toString().includes(props.refrence)
                  ? "setBg"
                  : ""
              }
            >
              {props.icon && <props.icon />}
            </span>
          </div>
          {/*<i className={props.className}/>*/}
          <span className={"mt-3"}>{props.title}</span>
        </Link>
      </li>
    );
  }
}
